export default __webpack_public_path__ + "static/media/er.3f755b44.svg";